"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const OpenInNew_1 = __importDefault(require("@material-ui/icons/OpenInNew"));
const navigation_context_1 = require("../../composite/navigation/navigation-context");
const tooltip_1 = require("../tooltip/tooltip");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const link_button_styles_1 = require("./link-button-styles");
function LinkButton({ to, replace, state }) {
    const { navigate } = (0, react_1.useContext)(navigation_context_1.NavigationContext);
    const classes = (0, link_button_styles_1.useStyles)();
    const handleClick = (0, event_callback_hook_1.useEventCallback)(() => {
        navigate(to, replace, state);
    });
    return (react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_AUTOCOMPLETE_DETAIL_TOOLTIP", defaultMessage: "Otev\u0159\u00EDt detail" }), placement: "top-start", type: "HOVER" },
        react_1.default.createElement(OpenInNew_1.default, { className: classes.root, onClick: handleClick })));
}
exports.LinkButton = LinkButton;
//# sourceMappingURL=link-button.js.map